module.exports = __webpack_public_path__ + "static/media/Cashapp.7f4cc931.png";